import React from 'react';
import PropTypes from 'prop-types';
import { usePropsContext } from '@uhg-abyss/web/hooks/usePropsContext';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { storage } from '@uhg-abyss/web/tools/storage';
import { Layout } from '@uhg-abyss/web/ui/Layout';

// const StyledModalSection1 = styled(Modal.Section, {
//   borderTop: '1px solid $black',
//   borderBottom: '1px solid $gray3',
// });

const StyledModalSection2 = styled(Modal.Section, {
  textAlign: 'center',
  borderTop: '1px solid $black',
  borderBottom: '1px solid $gray3',
});

const StyledModalText = styled('div', {
  margin: '5px 0 12px',
  lineHeight: '1.2',
});

export const RecoveryModal = ({ isOpen, closeModal }) => {
  const { data } = usePropsContext();

  const handleRecovery = (isRecovering) => {
    const idleRecoveryURL = storage.local.get(data.idleStorageKey);
    storage.local.remove(data.idleStorageKey);
    closeModal();

    if (isRecovering) {
      window.location.href = idleRecoveryURL;
    }
  };

  return (
    <Modal
      size={600}
      isOpen={isOpen}
      closeOnClickOutside={false}
      onClose={closeModal}
      title='Timeout Recovery'
      footer={
        <Modal.Section>
          <Layout.Group alignLayout='center'>
            <Button
              variant='outline'
              css={{ 'min-width': '200px' }}
              onClick={() => handleRecovery()}
            >
              No
            </Button>
            <Button
              css={{ 'min-width': '200px' }}
              onClick={() => handleRecovery(true)}
            >
              Yes
            </Button>
          </Layout.Group>
        </Modal.Section>
      }
    >
      <StyledModalSection2>
        <StyledModalText>
          Your previous session timed out. Would you like to return to your last
          visited page?
        </StyledModalText>
      </StyledModalSection2>
    </Modal>
  );
};

RecoveryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
